export default __webpack_public_path__ + "static/media/unboxing.54d34155.png";